<template>
  <div v-if="config" class="bottom">
    <div v-if="hasQualify" class="guide-wrapper" @click="$emit('go-next')">
      <div class="guide">{{ config.success_button.content }}</div>
      <div class="ios-padding"></div>
    </div>
    <div v-else class="pay-wrapper">
      <div v-if="!config.button.close_countdown" class="pay-block">
        <div>
          <div class="finish-tips">{{ config.button.label }}</div>
          <CountDown
            class="count-down"
            :config="countDownConfig"
            @next="handleNext"
            @finish="handleCountDownFinish"
          ></CountDown>
        </div>
        <div class="btn-pay" :class="{ disabled: !isAgree }" @click="handlePay">
          <div class="price-tip">
            <div class="action-title">{{ config.button.tip }}</div>
            <div class="del-price">{{ config.button.del_price }}</div>
          </div>
          <div class="price">{{ config.button.price }}</div>
        </div>
      </div>
      <div v-else class="pay-block-v2">
        <div class="price-block">
          <div class="price-info">
            <div class="price">{{ config.button.price }}</div>
            <div class="del-price">{{ config.button.del_price }}</div>
          </div>
          <div class="tip-info">
            <div class="tip">{{ config.button.tip }}</div>
            <div class="label">{{ config.button.label }}</div>
          </div>
        </div>
        <div :class="{ disabled: !isAgree }" class="btn-pay" @click="handlePay">
          {{ config.button.pay_btn_text }}
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator';
import CountDown from '@/modules/common/CountDown.vue';
import { getCookie, setCookie } from '@/lib/util';
const TimeFlag = 'time_record';
let recordTime = 0;
@Component({
  components: {
    CountDown,
  },
})
export default class Bottom extends Vue {
  @Prop({ type: Boolean }) isAgree!: boolean;
  @Prop({ type: Boolean, default: false }) isPaySuccess!: boolean;
  @Prop({ type: Object }) config!: any;
  @Prop({ type: Boolean, default: false }) hasQualify!: boolean;
  countDownConfig = { time: 0 };
  mounted() {
    this.countDownConfig.time = this.config.button.countdown_timestamp;
    // let time = getCookie(TimeFlag);
    const time = localStorage.getItem(TimeFlag);
    // localStorage.setItem()
    if (time) {
      const numberTime = Number(time);
      if (numberTime > 0 && numberTime < this.countDownConfig.time) {
        this.countDownConfig = { time: numberTime };
        recordTime = numberTime;
      }
    }
    // const unloadHandle = () => {
    //   console.log('before unload', recordTime);
    //   const expire = new Date(Date.now() + recordTime);
    //   localStorage.setItem(TimeFlag, recordTime + '');
    //   // setCookie(TimeFlag, recordTime + '', expire);
    //   return 0;
    // };
    // window.addEventListener('beforeunload', unloadHandle);

    // window.addEventListener('pagehide', unloadHandle);
  }
  handleNext(time: number) {
    recordTime = time;
    localStorage.setItem(TimeFlag, String(time));
  }
  handlePay() {
    this.$emit('pay');
  }
  handleCountDownFinish() {
    this.countDownConfig = { time: this.config.button.countdown_timestamp };
  }
}
</script>

<style lang="scss" scoped>
.guide-wrapper {
  background-image: linear-gradient(to left, #ff50bc, #ff8383);
  &:active {
    background-image: linear-gradient(270deg, #ff61c2 0%, #ff8f8f 100%);
  }
  .guide {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 120px;
    color: #ffffff;
    font-weight: 600;

    font-size: 40px;
    letter-spacing: 4px;
    user-select: none;
  }
}

.pay-block {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 750px;
  height: 130px;
  padding: 0 10px 0 45px;
  background: #ffffff;
  .finish-tips {
    color: #ef276a;
    font-weight: 500;
    font-size: 24px;
  }
  .count-down {
    margin-top: 13px;
  }
  .btn-pay {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 460px;
    height: 110px;
    padding: 0 48px 0 25px;
    color: #fff;
    font-weight: 600;
    background-image: linear-gradient(to left, #ff50bc, #ff8383);
    border-radius: 8px;
    user-select: none;
    .price-tip {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
    }
    &.disabled {
      opacity: 0.5;
    }
    &:active:not(.disabled) {
      background-image: linear-gradient(270deg, #ff61c2 0%, #ff8f8f 100%);
    }
    .action-title {
      font-size: 40px;
    }
    .price {
      font-size: 90px;
      &::after {
        position: relative;
        top: -4px;
        margin-left: 4px;
        color: #fff;
        font-weight: 600;
        font-size: 40px;
        content: '元';
      }
    }
    .del-price {
      position: relative;
      color: rgba(255, 255, 255, 0.8);
      font-size: 26px;
      &::before {
        position: absolute;
        top: 50%;
        left: 50%;
        display: block;
        width: 110%;
        height: 4px;
        background: rgba(255, 255, 255, 0.76);
        transform: translate(-50%, -50%) rotate(-4deg);
        content: '';
      }
    }
  }
}
.pay-block-v2 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 130px;
  padding: 0 10px 0 15px;
  background: #fff;
  .price-block {
    display: flex;
    align-items: center;
    .price-info,
    .tip-info {
      display: flex;
      flex-direction: column;
      align-items: center;
    }
    .tip-info {
      align-items: flex-start;
      margin-left: 9px;
    }
    .price {
      color: #3b3561;
      font-weight: 600;
      font-size: 60px;
      line-height: 1;
      &::before {
        margin-right: 8px;
        font-size: 40px;
        content: '¥';
      }
    }
    .del-price {
      position: relative;
      // line-height: 1;
      color: rgba(59, 53, 97, 0.41);
      // margin-top: 10px;
      font-size: 24px;
      &::before {
        position: absolute;
        top: 50%;
        left: 50%;
        display: block;
        width: 110%;
        height: 4px;
        background: rgba(164, 163, 185, 0.76);
        transform: translate(-50%, -50%) rotate(-4deg);
        content: '';
      }
    }
    .tip {
      color: #f55697;
      font-weight: 600;
      font-size: 24px;
    }
    .label {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 168px;
      height: 40px;
      color: #fff;
      font-weight: 500;
      font-size: 18px;
      background-image: linear-gradient(to left, #ff1a61, #ff9052);
      border-radius: 8px;
    }
  }
  .btn-pay {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 424px;
    height: 110px;
    color: #fff;
    font-weight: 600;
    font-size: 40px;
    background-image: linear-gradient(to left, #ff50bc, #ff8383);
    border-radius: 8px;
    &.disabled {
      opacity: 0.5;
    }
    &:active:not(.disabled) {
      background-image: linear-gradient(270deg, #ff61c2 0%, #ff8f8f 100%);
      user-select: none;
    }
  }
}
.pay-wrapper {
  position: relative;
  z-index: 10;
  // background-image: linear-gradient(270deg, #ff61c2 0%, #ff8f8f 100%);
  background: #fff;
  box-shadow: 0 -2px 8px 0 rgba(184, 184, 184, 0.5);
  // padding-top: 8px;
  // box-shadow: 0 -8px 0 0 red;
}
</style>
<style lang="scss">
// ios 安全区域 fix，在父元素中包含有这个类后，就应用 padding。至于在哪里加入这个类，就由组件调用方来决定
.ios-safe-bottom {
  .ios-padding {
    height: constant(safe-area-inset-bottom);
    height: env(safe-area-inset-bottom);
    // background-image: linear-gradient(to left, #ff50bc, #ff8383);
  }
  .pay-wrapper {
    padding-bottom: constant(safe-area-inset-bottom);
    padding-bottom: env(safe-area-inset-bottom);
  }
}
</style>
